/* tslint:disable */
/* eslint-disable */
/**
 * CheckFlow
 * CheckFlow
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PossibleStoreDto } from './PossibleStoreDto';
import {
    PossibleStoreDtoFromJSON,
    PossibleStoreDtoFromJSONTyped,
    PossibleStoreDtoToJSON,
} from './PossibleStoreDto';

/**
 * 
 * @export
 * @interface GetPossibleStoresViewModel
 */
export interface GetPossibleStoresViewModel {
    /**
     * 
     * @type {Array<PossibleStoreDto>}
     * @memberof GetPossibleStoresViewModel
     */
    possibleStores?: Array<PossibleStoreDto> | null;
    /**
     * 
     * @type {number}
     * @memberof GetPossibleStoresViewModel
     */
    readonly possibleStoreCount?: number;
}

/**
 * Check if a given object implements the GetPossibleStoresViewModel interface.
 */
export function instanceOfGetPossibleStoresViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetPossibleStoresViewModelFromJSON(json: any): GetPossibleStoresViewModel {
    return GetPossibleStoresViewModelFromJSONTyped(json, false);
}

export function GetPossibleStoresViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPossibleStoresViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'possibleStores': !exists(json, 'possibleStores') ? undefined : (json['possibleStores'] === null ? null : (json['possibleStores'] as Array<any>).map(PossibleStoreDtoFromJSON)),
        'possibleStoreCount': !exists(json, 'possibleStoreCount') ? undefined : json['possibleStoreCount'],
    };
}

export function GetPossibleStoresViewModelToJSON(value?: GetPossibleStoresViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'possibleStores': value.possibleStores === undefined ? undefined : (value.possibleStores === null ? null : (value.possibleStores as Array<any>).map(PossibleStoreDtoToJSON)),
    };
}

